import * as Yup from 'yup';

const toppingsCategoryItemSchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  toppingCategoryId: Yup.string().required('Primary Topping Category is required.'),
  additionalToppingCategoryIds: Yup.array()
    .of(Yup.string())
    .default([]),
  code: Yup.string().required('Code is required.'),
  position: Yup.number()
    .min(1, "Please enter more than 1")
    .typeError("Must be Number"),
  price: Yup.number()
    .min(0, 'Please enter more than 0')
    .required('Price is required.')
    .typeError('Must be Number'),
  effortScore: Yup.number()
    .min(1, 'Effort score must be at least 1')
    .required('Effort score is required.')
    .typeError('Must be Number')
    .default(10),
  previewUrl: Yup.string().required('Preview URL is required.'),
  // shapeItems: Yup.array().of(
  // Yup.object().shape({
  // shapeId: Yup.string().required('Shape is required.'),
  // sliced: Yup.string().required('Sliced Image is required.'),
  // top: Yup.string().required('Top Image is required.'),
  // front: Yup.string().required('Front Image is required.'),
  // })
  // ),
});

export default toppingsCategoryItemSchema;